import React from 'react'
import { Link } from 'gatsby'

import {
  Wrapper,
  Left,
  Right,
  Col,
  Icons,
  Logo,
  Insta,
  Eho,
  CookFox,
  Mag,
  De
} from './index.styled'

const Footer = ({ className }) => {
  return (
    <Wrapper className={className}>
      <Left>
        <Logo to='/' />
        <div>
          <Insta
            href='https://www.instagram.com/mabelchelseanyc/'
            target='_blank'
            rel='noreferrer'
          />

          <a
            href='/FactSheet.pdf'
            target='_blank'
            rel='noreferrer'
            className='mob-only fact'
          >
            Fact Sheet
          </a>
        </div>
      </Left>
      <Right>
        <Col className='zero web-only'>
          <a href='/FactSheet.pdf' target='_blank' rel='noreferrer'>
            Fact Sheet
          </a>
        </Col>
        <Col className='first'>
          <div>
            335 8th Avenue
            <br />
            New York, NY 10001
          </div>
          <Link to='/legal/' className='web-only'>
            Legal
          </Link>

          <div className='mob-only'>
            <a href='tel:6468839884'>(646) 883-9884</a>
            <a href='mailto:leasing@mabelchelsea.com'>
              leasing@mabelchelsea.com
            </a>
            <br />
          </div>
        </Col>
        <Col className='links'>
          <div className='web-only'>
            <a href='tel:6468839884'>(646) 883-9884</a>
            <a href='mailto:leasing@mabelchelsea.com'>
              leasing@mabelchelsea.com
            </a>
          </div>

          <div>
            <a
              href='/nys-housing-and-anti-discrimination-notice_06.2024.pdf'
              target='_blank'
              rel='noreferrer'
            >
              Fair Housing Notice
            </a>
            <a
              href='/fair-housing-notice.pdf'
              target='_blank'
              rel='noreferrer'
            >
              Notice for Reasonable Accommodations
            </a>
          </div>
          <Link to='/legal/' className='mob-only'>
            Legal
          </Link>
        </Col>
        <Col className='last'>
          <Icons>
            <Mag />
            <De />
            <CookFox />
          </Icons>
          <Eho />
        </Col>
      </Right>
    </Wrapper>
  )
}

export default Footer
